import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule, InputTextModule } from 'primeng/primeng';

import { ResetPasswordRoutingModule } from './reset-password-routing.module';
import { EmailVerificationComponent } from './email-verification/email-verification.component';
import { NewPasswordComponent } from './new-password/new-password.component';

@NgModule({
  imports: [
    CommonModule,
    ResetPasswordRoutingModule,
    ReactiveFormsModule,
    TranslateModule,
    ButtonModule,
    InputTextModule
  ],
  declarations: [
    EmailVerificationComponent,
    NewPasswordComponent
  ]
})

export class ResetPasswordModule { }



// WEBPACK FOOTER //
// /dist/src/app/user/reset-password/reset-password.module.ts